import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'removeHtmlTags' })
export class RemoveHtmlTagsPipe implements PipeTransform {
  transform(html: string): string {
    html = html?.toString();
    if(!html)return html;
    html = html.replace(/<[^>]*>/g, '');
    html = html.replace(/&nbsp;/g, ' ');
    return html;
  }
}
